module.exports = __webpack_public_path__ + "assets/a04a59bee49efb2a31048654ed6cc26f.mp3";